import WorkingHours from 'components/working-hours';
import useEditShopContext from 'contexts/shop.context';
import React from 'react';

const PreviewShopOpeningTime = () => {
  const { shopDetails } = useEditShopContext();

  return (
    <WorkingHours
      data={shopDetails.brand_working_hours}
      setData={() => {
        //
      }}
      disabled
    />
  );
};

export default PreviewShopOpeningTime;
